"use client";

import { create } from "zustand";

interface BookmarkState {
  bookmarks: Record<string, boolean>;
  set: (id: string, value: boolean) => void;
  getById: (id: string, initial?: boolean) => boolean;
  filterBookmarkedOnly: boolean;
  setFilterBookmarkedOnly: (value: boolean) => void;
}

export const useBookmarkStore = create<BookmarkState>((set, get) => ({
  bookmarks: {},
  filterBookmarkedOnly: false,
  set: (id, value) =>
    set((state) => ({
      bookmarks: { ...state.bookmarks, [id]: value },
    })),

  getById: (id, initial) => {
    const storeValue = get().bookmarks[id];
    return storeValue !== undefined ? storeValue : initial ?? false;
  },
  setFilterBookmarkedOnly: (value) => {
    set({ filterBookmarkedOnly: value });
  },
}));
